/**
 * Spinner Components
 * Reusable loading spinner components with brand colors
 */

/**
 * DualRingSpinner - Two concentric rings spinning in opposite directions
 * Uses brand colors: teal (primary) and orange (accent)
 */
export const DualRingSpinner = ({ size = 'md', className = '' }) => {
  const sizeClasses = {
    sm: 'w-6 h-6',
    md: 'w-10 h-10',
    lg: 'w-14 h-14',
  };

  const borderSizes = {
    sm: 'border-2',
    md: 'border-4',
    lg: 'border-4',
  };

  const innerInsets = {
    sm: 'inset-0.5',
    md: 'inset-1',
    lg: 'inset-1.5',
  };

  return (
    <div className={`relative ${sizeClasses[size]} ${className}`}>
      {/* Outer ring - primary color */}
      <div
        className={`absolute inset-0 rounded-full ${borderSizes[size]} border-transparent border-t-primary animate-spin`}
      />
      {/* Inner ring - orange accent, reverse direction */}
      <div
        className={`absolute ${innerInsets[size]} rounded-full ${borderSizes[size]} border-transparent border-b-orange-400 animate-spin`}
        style={{ animationDirection: 'reverse', animationDuration: '0.6s' }}
      />
    </div>
  );
};

/**
 * SimpleSpinner - Standard single-ring spinner
 * For use in buttons and smaller contexts
 */
export const SimpleSpinner = ({ size = 'md', className = '' }) => {
  const sizeClasses = {
    sm: 'h-4 w-4',
    md: 'h-6 w-6',
    lg: 'h-8 w-8',
  };

  return (
    <svg
      className={`animate-spin ${sizeClasses[size]} ${className}`}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
    >
      <circle
        className="opacity-25"
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        strokeWidth="4"
      />
      <path
        className="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      />
    </svg>
  );
};

export default DualRingSpinner;
